var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import clsx from 'clsx';
import { Text } from '../text';
import { useMenuGroupLabelStyles } from './menuGroupLabel.styles';
/**
 * Component for the menu group label
 * @private
 */
export var MenuGroupLabel = React.forwardRef(function (props, ref) {
    // Props
    var label = props.label, icon = props.icon, className = props.className, rest = __rest(props, ["label", "icon", "className"]);
    // Classes
    var menuGroupLabelClasses = useMenuGroupLabelStyles();
    var menuGroupLabelClassName = clsx(className, menuGroupLabelClasses.label);
    // Icon
    var render = _jsx(_Fragment, { children: label });
    if (icon) {
        var Icon = icon;
        render = (_jsxs(_Fragment, { children: [_jsx(Icon, { className: menuGroupLabelClasses.icon, style: { height: 12 }, height: 12 }), label] }));
    }
    return (_jsx(Text, __assign({ ref: ref, className: menuGroupLabelClassName, variant: "label", colorVariant: "faded" }, rest, { children: render })));
});
MenuGroupLabel.displayName = 'MenuGroupLabel';
